export default {
    All: "All",
    Agreements: "Agreements",
    Schedules: "Schedules",
    Sheets: "Sheets"
  };
  